module.exports = __webpack_public_path__ + "static/media/check-blue.b16f1fca.svg";